<template>
  <div
    class="forum-create-thought-button control-el d-inline"
    v-if="canCreateThought(topic) || canCreateThoughtAfterLogin(topic)"
  >
    <button class="btn btn-sm btn-primary" @click="openCreateThought">Neues Thema erstellen</button>
    <OverlayPanel
      v-if="!isLoggedIn"
      ref="loginOP"
      :showCloseIcon="true"
      :dismissable="true"
      appendTo="body"
      class="wdw-widgets"
    >
      <p>Um ein neues Thema zu erstellen, müssen Sie sich zunächst einloggen!</p>
      <Login :domainid="domainid" />
    </OverlayPanel>
  </div>
</template>

<script>
import { ref, computed, toRef } from 'vue';

// stores
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';

// components
import OverlayPanel from 'primevue/overlaypanel';
import Login from '@/components/user/Login.vue';

// composables
import useTopicConfig from '@/composables/topic/useTopicConfig';

export default {
  name: 'forum-create-thought-button',
  props: {
    topic: {
      type: Object,
      required: true,
    },
  },
  emit: ['create-thought'],

  setup(props, context) {
    const topic = toRef(props, 'topic');
    const loginOP = ref();
    const { canCreateThought, canCreateThoughtAfterLogin } = useTopicConfig();

    //
    //-----------------COMPUTED------------------
    //
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });

    //
    //-----------------METHODS------------------
    //

    function openCreateThought(event) {
      //Check if user is logged in
      if (canCreateThought(topic.value)) {
        context.emit('create-thought', {
          topicid: topic.value.id,
          name: topic.value.title,
        });
      } else if (canCreateThoughtAfterLogin(topic.value)) {
        loginOP.value.show(event);
      } else {
        console.error('error: cannot create thought, but button visible/clicked');
      }
    }

    return {
      // REFS
      loginOP,

      // COMPUTED
      domainid,
      isLoggedIn,

      // METHODS
      openCreateThought,
      canCreateThought,
      canCreateThoughtAfterLogin,
    };
  },

  components: {
    OverlayPanel,
    Login,
  },
};
</script>
